import { safeDefine } from "../../registration/safe-define.js";
import { VolumePopoverElement } from "../../ui/volume-popover/element.js";
//#region src/define/ui/volume-popover.ts
safeDefine(VolumePopoverElement);
//#endregion

//# sourceMappingURL=volume-popover.js.map